import { EmlMessage, generatePdf, HtmlGenerator, uniNewcomerHtml } from '@utils';
import { store } from '../store';
import { SubmissionEntityInterface } from '@types';
import CyrillicToTranslit from 'cyrillic-to-translit-js';
import { ImageShape } from '@enums';
import isEmpty from 'lodash/isEmpty';

export const generateSubmissionEml = async (
  isAttachmentPdf: boolean,
  letterName: string,
  submission: SubmissionEntityInterface
) => {
  const submissionEnvironment = store?.getState().submissionEnvironment;
  const submissionFormData = JSON.parse(submission.origin.form.data);
  const rendererData = !isEmpty(submission.origin?.originSections)
    ? uniNewcomerHtml
    : submission.origin?.formRenderer.data;

  const html = !isAttachmentPdf
    ? new HtmlGenerator(
        rendererData,
        submissionEnvironment,
        false,
        submission.origin?.originSections
      ).getHtml(true)
    : '';

  const downloadLink = document.createElement('a');
  /** Interpolating if the value is dynamic
   * providing context to be executed
   */
  const subject = new HtmlGenerator(submissionFormData?.subject, submissionEnvironment).getHtml();
  const to = {
    name: new HtmlGenerator(submissionFormData.recipientName, submissionEnvironment).getHtml(),
    email: new HtmlGenerator(submissionFormData.recipientEmail, submissionEnvironment).getHtml(),
  };
  const cc = new HtmlGenerator(submissionFormData.cc, submissionEnvironment).getHtml();

  const message = new EmlMessage(subject, to, html, [], { 'X-Unsent': '1', Cc: cc ? cc : '' });

  message.addAttachment(
    submissionEnvironment.attachments
      .filter((item) => message.html.includes(item.name))
      .map((item) => {
        const regexp = new RegExp(`<img[^>]+src="cid:${item.name}"[^>]*>`);
        const tag = message.html.match(regexp)?.[0];
        const shape = tag?.match(/(?<=data-shape=")\w+/)?.[0];
        switch (shape) {
          case ImageShape.CIRCLE: {
            return { ...item.data, data: item.data.data[ImageShape.CIRCLE] };
          }
          case ImageShape.SQUARE: {
            return { ...item.data, data: item.data.data[ImageShape.SQUARE] };
          }
          default: {
            return item.data;
          }
        }
      })
  );

  /**
   * If the file is a message with attached pdf
   */
  if (isAttachmentPdf) {
    const pdf = await generatePdf(true, letterName, submission);

    const cyrillicToTranslit = CyrillicToTranslit();

    message.addAttachment({
      name: `${cyrillicToTranslit.transform(`${letterName}`, '_')}.pdf`,
      data: pdf,
    });
  }

  downloadLink.download = `${letterName}.eml`;
  downloadLink.href = message.createMessage();
  downloadLink.click();
};
